/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Values are IETF language tags.
 * Combination of ISO 639-1 language code and ISO 3166-1 alpha-2 country code
 */
export enum Language {
    DE_DE = 'de-DE',
    EN_AU = 'en-AU',
    EN_GB = 'en-GB',
    EN_US = 'en-US',
    ES_ES = 'es-ES',
    FR_CA = 'fr-CA',
    FR_FR = 'fr-FR'
}
